import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authApi } from "../../utils/apiClients";
import defaultUser from "../../utils/default-user";

const initialState = {
  data: [],
  loading: false,
  batchId: null,
  batchNum: null,
};

// ✅ Login User
export const getAllData = createAsyncThunk(
  "overview/getAll",
  async ({ rejectWithValue }) => {
    try {
      authApi.get("v1/overview");
      return {
        isOk: true,
        data: defaultUser,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "no data");
    }
  }
);

// 🔥 Auth Slice
const overviewSlice = createSlice({
  name: "overview",
  initialState,
  reducers: {
    setBatchId: (state, action) => {
      state.batchId = action.payload[0];
    },
    setBatchNumber: (state, action) => {
      console.log("action.payload[0]", action.payload);
      state.batchNum = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.user;
      })
      .addCase(getAllData.rejected, (state, action) => {
        state.loading = false;
      });
  },
});
export const { setBatchId, setBatchNumber } = overviewSlice.actions;

export default overviewSlice.reducer;
